export default "__VITE_ASSET__5an4dEcW__"